import {createAction, props} from '@ngrx/store';
import {ApiScenarioHistoryListResponseDto, ApiScenarioListResponseDto, ApiScenarioOperationResponseDto} from '@birco/rainmesh-api';
import {ScenarioFilter} from './scenario.state';

const ACTION_PREFIX = '[Scenario]';

export const ScenarioActions = {
  public: {
    loadAllScenarios: createAction(
      `${ACTION_PREFIX} loadAllScenarios`,
    ),

    updateScenarioFilter: createAction(
      `${ACTION_PREFIX} updateScenarioFilter`,
      props<{ filter: ScenarioFilter }>(),
    ),

    loadScenarioHistory: createAction(
      `${ACTION_PREFIX} loadScenarioHistory`,
    ),

    runScenario: createAction(
      `${ACTION_PREFIX} runScenario`,
      props<{ id: string }>(),
    ),

    stopScenario: createAction(
      `${ACTION_PREFIX} stopScenario`,
      props<{ id: string }>(),
    ),

    scenarioStartedFromWebSocket: createAction(
      `${ACTION_PREFIX} scenarioStartedFromWebSocket`,
      props<{ scenarioId: string, displayName: string, startedAt: string, runtimeMinutes: number }>(),
    ),

    scenarioStoppedFromWebSocket: createAction(
      `${ACTION_PREFIX} scenarioStoppedFromWebSocket`,
      props<{ scenarioId: string }>(),
    ),
  },

  private: {
    loadScenariosWithFilters: createAction(
      `${ACTION_PREFIX} loadScenariosWithFilters`,
    ),

    loadScenariosSuccess: createAction(
      `${ACTION_PREFIX} loadScenariosSuccess`,
      props<{ scenariosResponseDto: ApiScenarioListResponseDto }>(),
    ),

    loadScenariosFailure: createAction(
      `${ACTION_PREFIX} loadScenariosFailure`,
      props<{ error: any }>(),
    ),

    loadScenarioHistorySuccess: createAction(
      `${ACTION_PREFIX} loadScenarioHistorySuccess`,
      props<{ historyResponseDto: ApiScenarioHistoryListResponseDto }>(),
    ),

    loadScenarioHistoryFailure: createAction(
      `${ACTION_PREFIX} loadScenarioHistoryFailure`,
      props<{ error: any }>(),
    ),

    runScenarioSuccess: createAction(
      `${ACTION_PREFIX} runScenarioSuccess`,
      props<{ id: string, responseDto: ApiScenarioOperationResponseDto }>(),
    ),

    runScenarioFailure: createAction(
      `${ACTION_PREFIX} runScenarioFailure`,
      props<{ id: string, error: any }>(),
    ),

    stopScenarioSuccess: createAction(
      `${ACTION_PREFIX} stopScenarioSuccess`,
      props<{ id: string, responseDto: ApiScenarioOperationResponseDto }>(),
    ),

    stopScenarioFailure: createAction(
      `${ACTION_PREFIX} stopScenarioFailure`,
      props<{ id: string, error: any }>(),
    ),
  }
};
